// extracted by mini-css-extract-plugin
export var discard = "_1z-4";
export var muiTooltipTooltip = "_1z-6";
export var notificationBar = "_1z-3";
export var notificationContainer = "_1z-2";
export var saveButtonHoverSlotWrapper = "_1z-5";
export var show = "_1z-1";
export var spacer = "_1z-0";